import { Box } from "@memorang/ui";
import { type KeyboardEvent, useRef } from "react";
import { StyleSheet } from "react-native";
import { TextInput } from "react-native-paper";

interface ChatInputProps {
	value: string;
	onChangeText: (text: string) => void;
	onSend: () => void;
	disabled?: boolean;
}

const ChatInput = ({
	value,
	onChangeText,
	onSend,
	disabled = false,
}: ChatInputProps) => {
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	const inputRef = useRef<any>(null);

	const handleSend = () => {
		if (value.trim()) {
			onSend();
			onChangeText(""); // Clear input after sending
			// Focus back on input after sending
			setTimeout(() => {
				inputRef.current?.focus();
			}, 0);
		}
	};

	const handleKeyPress = (e: KeyboardEvent) => {
		if (e.key === "Enter" && !e.shiftKey) {
			e.preventDefault();
			handleSend();
		}
	};

	const canSend = !disabled && value.trim().length > 0;

	return (
		<Box style={styles.container}>
			<TextInput
				ref={inputRef}
				placeholder="Type your message to the avatar..."
				value={value}
				onChangeText={onChangeText}
				disabled={disabled}
				mode="outlined"
				multiline={false}
				blurOnSubmit={true}
				returnKeyType="send"
				onKeyPress={(e) => handleKeyPress(e as unknown as KeyboardEvent)}
				right={
					<TextInput.Icon
						icon="send"
						onPress={handleSend}
						disabled={!canSend}
						style={{
							opacity: canSend ? 1 : 0.5,
						}}
					/>
				}
				style={styles.input}
			/>
		</Box>
	);
};

const styles = StyleSheet.create({
	container: {
		flex: 1,
	},
	input: {
		backgroundColor: "white",
	},
});

export default ChatInput;
